(() => {
  const descriptionSelector = '.product__description details';

  const isSizeChart = (details) => {
    const summary = details.querySelector(':scope > summary');
    if (!summary) return false;

    const normalizedLabel = summary.textContent.replace(/\s+/g, '').toLowerCase();
    return normalizedLabel.includes('sizechart') && normalizedLabel.includes('taptoexpand');
  };

  const closeSizeCharts = (root = document) => {
    const candidates = [];

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(descriptionSelector)) {
      candidates.push(root);
    }

    if (root.querySelectorAll) {
      candidates.push(...root.querySelectorAll(descriptionSelector));
    }

    candidates.forEach((details) => {
      if (isSizeChart(details)) details.removeAttribute('open');
    });
  };

  const initialize = () => {
    closeSizeCharts();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => closeSizeCharts(node));
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
